import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/v1/sale-areas', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const find = (id, Options = {}) => {
  return httpClient
    .get(`/api/v1/sale-areas/${id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/v1/sale-areas', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = (id, data) => {
  return httpClient
    .put(`/api/v1/sale-areas/${id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const destroy = id => {
  return httpClient
    .delete(`/api/v1/sale-areas/${id}`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const province = () => {
  return httpClient
    .get('/api/v1/sale-areas/provinces')
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const district = (Options = {}) => {
  return httpClient
    .get('/api/v1/sale-areas/districts', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const commune = (Options = {}) => {
  return httpClient
    .get('/api/v1/sale-areas/communes', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const sale = (Options = {}) => {
  return httpClient
    .get('/api/v1/sale-areas/sale-offices', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  get,
  find,
  store,
  update,
  destroy,
  province,
  district,
  commune,
	sale
}
